<template>
    <el-dialog :top="'32vh'" :visible.sync="dialogVisible" width="30%">
        <div class="title" slot="title">
            <i class="el-icon-warning icon"></i>
            <div class="text">提示</div>
        </div>
        <span class="winText" v-html="contentText"></span>
        <div class="footerBox">
            <el-button v-if="type == 1" @click="cancelFun">取 消</el-button>
            <el-button type="primary" @click="confirmFun">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'HintWin',
    props: {},
    data() {
        return {
            dialogVisible: false,
            contentText: '',
            type: 0, // 状态：0.提示弹窗，1.确认弹窗
            confirmBackFun: {},
        }
    },
    methods: {
        init(text = '', type = 0) {
            if (type == 1) {
                return new Promise(async (resolve, reject) => {
                    this.dialogVisible = true
                    this.contentText = text
                    this.type = type
                    this.confirmBackFun = resolve
                })
            } else {
                this.dialogVisible = true
                this.contentText = text
                this.type = type
            }
        },
        confirmFun() {
            this.dialogVisible = false
            if (this.type == 1 && this.confirmBackFun) {
                this.confirmBackFun('confirm')
            }
        },
        cancelFun() {
            this.dialogVisible = false
            this.confirmBackFun('cancel')
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
    padding: 10px 20px;
}

.title {
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
        font-size: 24px;
        color: #ff5310;
        position: relative;
        left: -6px;
    }

    .text {
        position: relative;
        left: -6px;
        font-size: 16px;
        line-height: 16px;
        font-weight: bold;
        color: #303133;
        margin-left: 6px;
    }
}

.winText {
    font-size: 15px;
    line-height: 24px;
    color: #303133;
}

.footerBox {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-top: 10px;
}
@media screen and (max-width: 1024px) {
    /deep/.el-dialog {
        width: 90% !important;
    }
    /deep/ .el-dialog__body {
        padding: 10px 20px;
    }
    /deep/.el-button--primary {
        padding: 5px 40px !important;
    }
    .title {
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
            font-size: 24px;
            color: #ff5310;
            position: relative;
            left: -6px;
        }

        .text {
            position: relative;
            left: -6px;
            font-size: 16px;
            line-height: 16px;
            font-weight: bold;
            color: #303133;
            margin-left: 6px;
        }
    }

    .winText {
        font-size: 15px;
        line-height: 24px;
        color: #303133;
    }

    .footerBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-top: 10px;
    }
}
</style>
